import { default as indexFADheRMvXIMeta } from "/vercel/path0/pages/app/chat/index.vue?macro=true";
import { default as detail65A73stnEkMeta } from "/vercel/path0/pages/app/content/[id]/detail.vue?macro=true";
import { default as indexcfTliEyvhiMeta } from "/vercel/path0/pages/app/content/[id]/index.vue?macro=true";
import { default as editorchzoOdJRNFMeta } from "/vercel/path0/pages/app/content/editor.vue?macro=true";
import { default as _91id_93GXTklDBwAuMeta } from "/vercel/path0/pages/app/content/v2/[id].vue?macro=true";
import { default as service_45unavailableRURpclmL0VMeta } from "/vercel/path0/pages/app/service-unavailable.vue?macro=true";
import { default as what_45is_45oeONFzb7LdB6Meta } from "/vercel/path0/pages/app/what-is-oe.vue?macro=true";
import { default as _91id_93bVyATJrmnRMeta } from "/vercel/path0/pages/content/[id].vue?macro=true";
import { default as for_45appLD2f3WrIbGMeta } from "/vercel/path0/pages/content/host/introduce/for-app.vue?macro=true";
import { default as indexPQ86JAPjvRMeta } from "/vercel/path0/pages/content/host/introduce/index.vue?macro=true";
import { default as _91id_930ekg58uS4iMeta } from "/vercel/path0/pages/gathering/[id].vue?macro=true";
import { default as _91id_93bZWdTBZ7oWMeta } from "/vercel/path0/pages/gathering/feed/[id].vue?macro=true";
import { default as listvHI6cfzy7SMeta } from "/vercel/path0/pages/gathering/feed/list.vue?macro=true";
import { default as listhEDqx6uSPhMeta } from "/vercel/path0/pages/gathering/list.vue?macro=true";
import { default as notfoundmui9CxnzfvMeta } from "/vercel/path0/pages/gathering/notfound.vue?macro=true";
import { default as indexe9Brt5DfdhMeta } from "/vercel/path0/pages/index.vue?macro=true";
import { default as introduceOEgc21NtHKqjMeta } from "/vercel/path0/pages/introduceOE.vue?macro=true";
import { default as _91groupId_93ObTK6GlMXtMeta } from "/vercel/path0/pages/product/emoticon/[groupId].vue?macro=true";
import { default as _91id_93dRjblFD3G3Meta } from "/vercel/path0/pages/promotion/[id].vue?macro=true";
import { default as chat_45roomqp3ngWOcRZMeta } from "/vercel/path0/pages/publishing/chat-room.vue?macro=true";
export default [
  {
    name: "app-chat",
    path: "/app/chat",
    meta: indexFADheRMvXIMeta || {},
    component: () => import("/vercel/path0/pages/app/chat/index.vue")
  },
  {
    name: "app-content-id-detail",
    path: "/app/content/:id()/detail",
    component: () => import("/vercel/path0/pages/app/content/[id]/detail.vue")
  },
  {
    name: "app-content-id",
    path: "/app/content/:id()",
    component: () => import("/vercel/path0/pages/app/content/[id]/index.vue")
  },
  {
    name: "app-content-editor",
    path: "/app/content/editor",
    component: () => import("/vercel/path0/pages/app/content/editor.vue")
  },
  {
    name: "app-content-v2-id",
    path: "/app/content/v2/:id()",
    component: () => import("/vercel/path0/pages/app/content/v2/[id].vue")
  },
  {
    name: "app-service-unavailable",
    path: "/app/service-unavailable",
    component: () => import("/vercel/path0/pages/app/service-unavailable.vue")
  },
  {
    name: "app-what-is-oe",
    path: "/app/what-is-oe",
    component: () => import("/vercel/path0/pages/app/what-is-oe.vue")
  },
  {
    name: "content-id",
    path: "/content/:id()",
    component: () => import("/vercel/path0/pages/content/[id].vue")
  },
  {
    name: "content-host-introduce-for-app",
    path: "/content/host/introduce/for-app",
    component: () => import("/vercel/path0/pages/content/host/introduce/for-app.vue")
  },
  {
    name: "content-host-introduce",
    path: "/content/host/introduce",
    component: () => import("/vercel/path0/pages/content/host/introduce/index.vue")
  },
  {
    name: "gathering-id",
    path: "/gathering/:id()",
    component: () => import("/vercel/path0/pages/gathering/[id].vue")
  },
  {
    name: "gathering-feed-id",
    path: "/gathering/feed/:id()",
    component: () => import("/vercel/path0/pages/gathering/feed/[id].vue")
  },
  {
    name: "gathering-feed-list",
    path: "/gathering/feed/list",
    component: () => import("/vercel/path0/pages/gathering/feed/list.vue")
  },
  {
    name: "gathering-list",
    path: "/gathering/list",
    component: () => import("/vercel/path0/pages/gathering/list.vue")
  },
  {
    name: "gathering-notfound",
    path: "/gathering/notfound",
    component: () => import("/vercel/path0/pages/gathering/notfound.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/vercel/path0/pages/index.vue")
  },
  {
    name: "introduceOE",
    path: "/introduceOE",
    component: () => import("/vercel/path0/pages/introduceOE.vue")
  },
  {
    name: "product-emoticon-groupId",
    path: "/product/emoticon/:groupId()",
    component: () => import("/vercel/path0/pages/product/emoticon/[groupId].vue")
  },
  {
    name: "promotion-id",
    path: "/promotion/:id()",
    component: () => import("/vercel/path0/pages/promotion/[id].vue")
  },
  {
    name: "publishing-chat-room",
    path: "/publishing/chat-room",
    component: () => import("/vercel/path0/pages/publishing/chat-room.vue")
  }
]